module.exports = __webpack_public_path__ + "static/banner-image-462e5dd26d275c60b68addec64be03f4.png";